import { getModifierItemAmount } from './chunk-YVNW47EA.mjs';
import { menuModifierGroupsCardFactory } from './chunk-Z7DLDP7J.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import sortBy from 'lodash/sortBy';

var menuModifierGroupsTableFactoryCore = (modifierGroups, modifierItems) => menuModifierGroupsCardFactory(modifierGroups).map((modifierGroup) => {
  const menuModifierGroup = modifierGroups[modifierGroup.id];
  return __spreadProps(__spreadValues({}, modifierGroup), {
    quantityMode: menuModifierGroup.quantityMode,
    maximumModifierItems: menuModifierGroup.maximumModifierItems,
    includedModifierItems: menuModifierGroup.includedModifierItems,
    requiredModifierItems: menuModifierGroup.requiredModifierItems,
    modifierItems: sortBy(
      Object.values(menuModifierGroup.modifierItems),
      (modifierItem) => modifierItem.isSelected ? -1 : modifierItem.sortPriority
    ).map((modifierItem) => ({
      text: `${modifierItems[modifierItem.modifierItemId].name}${modifierItem.isSelected && getModifierItemAmount(menuModifierGroup.quantityMode, modifierItem) ? ` (${getModifierItemAmount(menuModifierGroup.quantityMode, modifierItem)})` : ""}`,
      isDefault: modifierItem.isSelected
    }))
  });
});

export { menuModifierGroupsTableFactoryCore };
